import {Observable } from 'rxjs';

export abstract class MysterShopperData {
    abstract getChannelListData():Observable<any[]>;
    abstract addMysteryTemplateData(data:any):Observable<any[]>;
    abstract getMysteryTemplateData():Observable<any[]>;
    
} 